import { PRODUCTS_TYPE } from "@/_old/constants/products";
import {
  getNameProductProp,
  variantsColorsProduct,
} from "./get-name-product.types";

const textByProductId: {
  [k in PRODUCTS_TYPE]: string;
} = {
  [PRODUCTS_TYPE.SHARED_SPACE]: "product-title-shared-space",
  [PRODUCTS_TYPE.PRIVATE]: "product-title-private",
  [PRODUCTS_TYPE.EXCLUSIVE]: "product-title-exclusive",
  [PRODUCTS_TYPE.MEETING_ROOM]: "product-title-meeting-room",
  [PRODUCTS_TYPE.EVENTS]: "product-title-events",
};

const colorByProduct: {
  [k in PRODUCTS_TYPE]: variantsColorsProduct;
} = {
  [PRODUCTS_TYPE.SHARED_SPACE]: "primary-500",
  [PRODUCTS_TYPE.PRIVATE]: "complementary01-500",
  [PRODUCTS_TYPE.EXCLUSIVE]: "complementary03-500",
  [PRODUCTS_TYPE.MEETING_ROOM]: "complementary02-500",
  [PRODUCTS_TYPE.EVENTS]: "complementary04-500",
};

export const getNameProduct = (id: getNameProductProp) => {
  return textByProductId[id] || textByProductId[PRODUCTS_TYPE.SHARED_SPACE];
};

export const getColorByProduct = (id: getNameProductProp) => {
  return colorByProduct[id] || colorByProduct[PRODUCTS_TYPE.SHARED_SPACE];
};
